import { render, staticRenderFns } from "./ConferenceSessionDetail.vue?vue&type=template&id=5f128e00&scoped=true"
import script from "./ConferenceSessionDetail.vue?vue&type=script&lang=js"
export * from "./ConferenceSessionDetail.vue?vue&type=script&lang=js"
import style0 from "./ConferenceSessionDetail.vue?vue&type=style&index=0&id=5f128e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f128e00",
  null
  
)

export default component.exports